// extracted by mini-css-extract-plugin
export default {"label":"TextInput_label__GULpd","input":"TextInput_input__e85SP"};